'use client';

import { faCalendarCheck } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { cn } from '@/utils/cn-tw-merge';
import { ButtonProps } from '@/components/ui/button/button.types';
import { handleOpenSearchModal } from '@/store/search/handle-open-search-modal';
import { AnalyticsEnumKeyType } from '@/types/enums/analytics/analytics.enum';

interface MedprevOnlineScheduleButtonProps extends ButtonProps {
  titleButton?: string;
  ['data-analytics-event']?: AnalyticsEnumKeyType;
  from?: string;
  sessionName?: string;
}

export const MedprevOnlineScheduleButton = ({
  className,
  titleButton = 'Agendar pelo site',
  color = 'success',
  from,
  sessionName,
  'data-analytics-event': analyticsEventName,
  onClick,
  ...props
}: MedprevOnlineScheduleButtonProps) => {
  return (
    <Button
      data-testid={DataTestIdEnum.CITY_MEDPREV_ONLINE_SCHEDULE_BUTTON}
      color={color}
      startIcon={faCalendarCheck}
      className={cn('h-12', className)}
      data-analytics-event={analyticsEventName}
      data-analytics-properties={JSON.stringify({
        secao_origem: from,
        nome_secao: sessionName,
      })}
      onClick={(event) => {
        onClick?.(event);
        handleOpenSearchModal();
      }}

      {...props}
    >
      {titleButton}
    </Button>
  );
};
